<template>
  <div class="filterItemsContainer">
    <c-filter-item
      v-for="item in items"
      :item="item"
      :key="item.id"
      :loading="loading"
      :show-chevron="showChevrons"
      @filter-selected="$emit('filter-selected', $event)"
    ></c-filter-item>
  </div>
</template>

<script>
import FilterItem from '@/components/pages/filter/FilterItem'

export default {
  components: { 'c-filter-item': FilterItem },
  props: { items: { required: true, type: Array }, loading: Boolean, showChevrons: Boolean },
}
</script>
